import "firebase/storage"
import { memo } from "react"
import { useStorage, useStorageDownloadURL } from "reactfire"
import { AspectRatio, Box, Image, Spinner } from "@chakra-ui/react"

const getThumb = (path) => {
  var chunks = path.split(".")
  chunks[chunks.length - 2] = chunks[chunks.length - 2] + "_800x600"
  return chunks.join(".")
}

const FetchImage = ({ src }) => {
  const storage = useStorage()
  const { status, data: imageURL } = useStorageDownloadURL(
    storage.ref(getThumb(src))
  )

  return status === "loading" ? (
    <AspectRatio bg="gray.200" ratio={4 / 3}>
      <Box>
        <Spinner />
      </Box>
    </AspectRatio>
  ) : (
    <AspectRatio bg="gray.200" ratio={4 / 3}>
      <Image
        borderRadius="sm"
        width="full"
        objectFit="cover"
        src={imageURL}
        fallbackSrc="https://via.placeholder.com/70"
      />
    </AspectRatio>
  )
}

const ProductImage = ({ src, showEmpty, ...props }) => {
  return src ? (
    <FetchImage src={src} />
  ) : showEmpty ? (
    <AspectRatio bg="gray.200" ratio={4 / 3}>
      <Box></Box>
    </AspectRatio>
  ) : (
    <span></span>
  )
}

export default memo(ProductImage)
